import { render, staticRenderFns } from "./newradar.vue?vue&type=template&id=1a92ab79&"
import script from "./newradar.vue?vue&type=script&lang=js&"
export * from "./newradar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports